// src/stores/auth.ts
//
// Estado de autenticación del inspector. Persistido en localStorage
// para que el inspector no tenga que loguearse en cada turno.

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Inspector = {
  id: number;
  nombre: string;
  apellido: string;
  email: string;
  municipio_id: number;
  legajo: string | null;
};

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  inspector: Inspector | null;
  setSession: (accessToken: string, refreshToken: string, inspector: Inspector) => void;
  logout: () => void;
};

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      inspector: null,
      setSession: (accessToken, refreshToken, inspector) =>
        set({ accessToken, refreshToken, inspector }),
      logout: () => set({ accessToken: null, refreshToken: null, inspector: null }),
    }),
    {
      name: 'ciudadapp-inspector-auth',
    }
  )
);
